import { Component, Input } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

interface IProductWarrantyBlockDataContent {
    image: string;
}

@Component({
    selector: 'product-warranty',
    templateUrl: './product-warranty.html',
    standalone: true,
    imports: [ImageModule]
})
@ICmsComponent<ProductWarrantyComponent>({
    id: 'cms-product-warranty',
    block: {
        url: 'cms-product-warranty'
    },
    onDemandOnly: true,
    name: 'Product Warranty',
    description: 'Product Warranty',
    fields: [{ key: 'image', type: NICmsContentField.EFieldType.image, title: 'Image', required: true }]
})
export class ProductWarrantyComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IProductWarrantyBlockDataContent;

    @Input()
    copy?: string;
}
